import store from '@/store/store';

export default {
  path: 'send-referral',
  name: 'app-send-referral',
  component: () => import('@/views/app/send_referral/SendReferral.vue'),
  meta: {
    pageTitle: '',
    pageTitleParams: null
  },
  beforeEnter: async (to, from, next) => {
    const profileResource = await store.state.router.profileResource;
    to.meta.pageTitle = 'send_referral.header_title';
    to.meta.pageTitleParams = {name: profileResource.organization};

    const prepareReferralCreateResource = await store.state.router.privateRoot.$request().$get('referral-send');
    store.commit('router/updateRouteProp', {
      property: 'prepareReferralCreateResource',
      value: prepareReferralCreateResource
    });

    let sourceReferralResource = null;
    if (to.query.sourceReferralId) {
      sourceReferralResource = await prepareReferralCreateResource.$request().$get('referral', {id: to.query.sourceReferralId});
      if (!sourceReferralResource.$hasLink('edit')) {
        sourceReferralResource = null;
      }
    }
    store.commit('router/updateRouteProp', {
      property: 'sourceReferralResource',
      value: sourceReferralResource
    });

    next();
  },
  props: () => ({
    prepareReferralCreateResource: store.state.router.prepareReferralCreateResource,
    sourceReferralResource: store.state.router.sourceReferralResource
  })
};
